import { FC, useRef } from 'react';

import { useDisclosure } from '@bonusly/design-system';
import { useEventListener } from '@bonusly/events';

import { FeedbackEvent } from '../../types/feedback-event';
import { OpenFeedbackRequestEventData, useFeedbackModalProps } from './hooks/use-feedback-modal-props';
import { RequestFeedbackModal } from './request-feedback-modal';

export const GlobalRequestFeedbackModal: FC = () => {
	const modal = useDisclosure();
	const eventDataRef = useRef<OpenFeedbackRequestEventData>({});
	const props = useFeedbackModalProps(eventDataRef.current);

	useEventListener(FeedbackEvent.OpenRequest, (data: OpenFeedbackRequestEventData) => {
		eventDataRef.current = data || {};
		modal.onOpen();
	});

	return <RequestFeedbackModal {...props} {...modal} />;
};
